import React, { useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { collection, query, orderBy, getDocs } from "firebase/firestore";
import { db } from "../../lib/firebase";
import { ParentOrder } from "../../types/index";
import { OrderCard } from "../../components/order/OrderCard";
import { Spinner } from "../../components/common/Spinner";

const getAllOrders = async (): Promise<ParentOrder[]> => {
  const q = query(collection(db, "parent_orders"), orderBy("createdAt", "desc"));
  const snapshot = await getDocs(q);
  return snapshot.docs.map(doc => ({ id: doc.id, ...doc.data() } as ParentOrder));
};

interface OrderSectionProps {
  trigger: number;
  onAdminEvent: () => void;
}

export const OrderSection: React.FC<OrderSectionProps> = ({ trigger, onAdminEvent }) => {
  
  const { data: orders = [], isLoading, refetch } = useQuery(["adminAllOrders"], getAllOrders);

  // Listen for trigger changes from parent to refetch data
  useEffect(() => {
    if (trigger) {
        refetch();
    }
  }, [trigger, refetch]);

  if (isLoading) return <div className="flex justify-center p-10"><Spinner /></div>;

  return (
    <div>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-xl font-bold text-gray-900">All Active Orders</h2>
        <span className="bg-blue-100 text-blue-800 text-xs font-semibold px-2.5 py-0.5 rounded">
            Total: {orders.length}
        </span>
      </div>
      
      <div className="space-y-6">
        {orders.length === 0 ? (
            <p className="text-gray-500 text-center py-10 bg-white rounded-lg border border-dashed">No orders found.</p>
        ) : (
            orders.map(order => (
            <OrderCard key={order.id} order={order} />
            ))
        )}
      </div>
    </div>
  );
};